module.exports = __webpack_public_path__ + "media/images/img_step_arrow_l-0f012c7148dc7ea07d69fc1c7d4e63c1.png";